import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    backgroundColor: theme.palette.custom.pageBackground,
    // Makes native scrollbars / form controls follow the active theme.
    colorScheme: theme.palette.type,
    '& .MuiPaper-root': {
      elevation: 3,
    },
  },
  title: {
    fontSize: '19px',
    margin: '10px',
    marginTop: '30px',
    fontWeight: 600,
    color: theme.palette.primary.mainBlue,
  },
}));

export default useStyles;
